<template>
	<div class="home text-left"  style="z-index: 9999;">
	<h2>Confirm Your Order</h2><br>
		
		<div v-show="is_ready">
			<div class="panel panel-default" style="padding:10px;">
				<table class="table table-condensed borderless mbn">
					<tr>
						<td><b>From:</b></td>
						<td>{{ order.email.from }}</td>
					</tr>
					<tr>
						<td><b>Subject:</b></td>
						<td>{{ order.email.subject }}</td>
					</tr>
					<tr>
						<td><b>Sent:</b></td>
						<td>{{ order.email.timestamp }}</td>
					</tr>
				</table>
			</div>
			<div class="panel panel-default">
				<table class="table table-condensed borderless mbn">
					<thead>
						<tr>
							<th class="active col-sm-6 text-left">
								<b>Filename</b>
							</th>
							<th class="active col-sm-2 text-center">
								<b>Timestamp</b>
							</th>
							<th class="active col-sm-2 text-right">
								<b>Size</b>
							</th>
							<th class="active col-sm-2 text-right">
								<b>Fee</b>
							</th>
						</tr>
					</thead>
					<tbody class="text-center">
						<tr v-for="file in order.files" :id="file.id" :key="file.id">
							<td  class="text-left">
								{{ file.name }}
							</td>
							<td  class="text-center">
								{{ file.timestamp }}
							</td>
							<td  class="text-right">
								{{ file.size }}
							</td>
							<td  class="text-right">
								{{ file.price }}
							</td>
						</tr>
						<tr>
							<td colspan=3 class="text-right">
								<b>Total:</b>
							</td>
							<td  class="text-right" style="border-top:double;">
								<b>£&nbsp;{{ order.email.fee }}</b>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<br><br>
			<a :href=paypal_url class="pull-right"><img src="../assets/images/44_Yellow_CheckOut_Pill_Button.png" /></a>
		</div>
	</div>
</template>


<script>

export default {
	name: 'order',

	data() {
		return {
			email_reference: '',
			order:           { email : '' },
			order_retrieved: false,
			paypal_url:      '',
		};
	},

	computed: {
		is_ready() {
			return (this.order_retrieved);
		}
	},
	
	created() {
		// Get email_queue_ref from URL
		this.email_reference = this.$route.params.reference;
		
		// Get email and attachments info
		this.get_order(this.email_reference);
	},

	mounted() {
	},

	methods: {
		//Gets Users Bets
		get_order(email_ref) {
			let vm = this;

			// Order will look like this:
			// email  {email info}
			// files [{file info}, {file2 info}, ...]
			var order;
			
			// Call API for files
			const post_data = {
				reference: email_ref,
			};

			this.axios.post('api/email_order', post_data)
			.then(response => {
				vm.order           = response.data;
				vm.paypal_url      = vm.axios.defaults.baseURL + 'api/paypal/payment?ref=' + vm.order.email.reference;
				vm.order_retrieved = true;
			})
			.catch(error => {
				var error_msg = 'An error occured.';
				if (error.response.data.message) {
					error_msg = error.response.data.message;	
				}
				
				this.$notify({
					group: "fs_danger",
					title: "Error",
					text: error_msg,
					type: "error"
				});
			});
		},
	},
}

</script>
